import { render } from "./CustomTreeView.vue?vue&type=template&id=dbfc665a&ts=true"
import script from "./CustomTreeView.vue?vue&type=script&lang=ts"
export * from "./CustomTreeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__